"use strict";
// http://ilmatieteenlaitos.fi/latauspalvelun-pikaohje for latest weatherSymbol reference
Object.defineProperty(exports, "__esModule", { value: true });
exports.weatherSymbols = void 0;
exports.weatherSymbols = {
    1: 'Clear',
    2: 'Partly cloudy',
    21: 'Light rain showers',
    22: 'Rain showers',
    23: 'Heavy rain showers',
    3: 'Cloudy',
    31: 'Light rain',
    32: 'Rain',
    33: 'Heavy rain',
    41: 'Light snow showers',
    42: 'Snow showers',
    43: 'Heavy snow showers',
    51: 'Light snowfall',
    52: 'Snowfall',
    53: 'Heavy snowfall',
    61: 'Thundershowers',
    62: 'Strong thundershowers',
    63: 'Thunder',
    64: 'Heavy thunder',
    71: 'Light sleet showers',
    72: 'Sleet showers',
    73: 'Heavy sleet showers',
    81: 'Light sleet',
    82: 'Sleet',
    83: 'Heavy sleet',
    91: 'Fog',
    92: 'Fog'
};
//# sourceMappingURL=weatherSymbols.js.map